import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DoRight from "@/components/ques/DoRight.vue";
export default {
  name: "ExamDoRight",
  components: {
    DoRight: DoRight
  },
  props: {
    limitTime: {
      type: Number,
      default: 0
    },
    shotAnswerEditable: {},
    reportId: {},
    scantron: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasSection: {
      type: Boolean,
      default: false
    },
    answerImg: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    answer: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      current: {},
      visible: false,
      index: "",
      is_confirm: 0
    };
  },
  computed: {
    total: function total() {
      return this.scantronQuestions.length;
    },
    answerCount: function answerCount() {
      return this.scantronQuestions.filter(function (q) {
        return q.status == 1 || q.status == 2;
      }).length;
    },
    scantronQuestions: function scantronQuestions() {
      if (!this.scantron.data) {
        return [];
      }

      if (this.hasSection) {
        var list = [];
        this.scantron.data.forEach(function (t) {
          t.child.forEach(function (ques) {
            list.push(ques);
          });
        });
        return list;
      } else {
        return this.scantron.data;
      }
    }
  },
  watch: {
    "$store.state.showQuestionAnswer": {
      handler: function handler(val) {
        this.is_confirm = val;
        if (val.is_confirm && val.get) this.$refs["right"].submitTopic();
      },
      deep: true
    }
  },
  methods: {
    init: function init(index, seconds) {
      this.$refs.right.init(index, seconds);
    },
    onGetTopic: function onGetTopic(_ref) {
      var _this = this;

      var reportId = _ref.reportId,
          index = _ref.index;
      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(resolve) {
          var data;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.$http.get("/api/app/practice/question/" + reportId, {
                    page: index
                  });

                case 2:
                  data = _context.sent;

                  if (!(data.code == 203)) {
                    _context.next = 11;
                    break;
                  }

                  _this.visible = true;
                  _this.reportId = reportId;
                  _this.question_id = data.data.error[0].question_id;
                  _this.index = index;

                  _this.$store.commit("setShowQuestionAnswer", {
                    is_confirm: data.data.error[0].is_confirm,
                    get: false
                  });

                  _this.getQuestionData({
                    getAnswer: _this.$store.state.questionModeSelect == 2 && data.data.error[0].is_confirm == 1,
                    data: _objectSpread({}, data.data, {
                      list: [_objectSpread({}, data.data.error[0])]
                    }) //判定

                  });

                  return _context.abrupt("return");

                case 11:
                  _this.reportId = reportId;
                  _this.question_id = data.data[0].question_id;
                  _this.index = index;

                  _this.$store.commit("setShowQuestionAnswer", {
                    is_confirm: data.data[0].is_confirm,
                    get: false
                  });

                  _this.getQuestionData({
                    getAnswer: _this.$store.state.questionModeSelect == 2 && data.data[0].is_confirm == 1,
                    data: data
                  });

                  resolve();

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    getQuestionData: function () {
      var _getQuestionData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(_ref3) {
        var getAnswer, data, ques;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getAnswer = _ref3.getAnswer, data = _ref3.data;

                if (!getAnswer) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return this.$http.post("/api/app/practice/getOneAnalysis", {
                  report_id: this.reportId,
                  question_id: this.question_id
                });

              case 4:
                data = _context2.sent;

              case 5:
                ques = Array.isArray(data.data) ? data.data[0] : data;

                if (ques.ques_type != 5 && ques.ques_type != 7 && typeof ques.ques_option === "string") {
                  ques.ques_option = JSON.parse(ques.ques_option);
                }

                ques.index = this.index;
                this.current = ques;
                this.$store.commit("setShowQuestionAnswer", {
                  is_confirm: ques.is_confirm,
                  get: false
                });
                this.$emit("topicChange", ques);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getQuestionData(_x2) {
        return _getQuestionData.apply(this, arguments);
      }

      return getQuestionData;
    }(),
    onSubmitTopic: function onSubmitTopic(_ref4) {
      var _this2 = this;

      var report_id = _ref4.report_id,
          question_id = _ref4.question_id,
          user_answer = _ref4.user_answer,
          answer_time = _ref4.answer_time,
          question = _ref4.question;
      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref5 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(resolve) {
          var data;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (question.ques_type == 5) {
                    if (user_answer != "" || _this2.answerImg[question_id] && _this2.answerImg[question_id].length > 0) {
                      user_answer = JSON.stringify({
                        content: user_answer,
                        images: _this2.answerImg[question_id] || []
                      });
                    }
                  }

                  _context3.next = 3;
                  return _this2.$http.post("/api/app/practice/storeQuestion", {
                    report_id: report_id,
                    question_id: question_id,
                    user_answer: user_answer,
                    answer_time: answer_time,
                    is_confirm: _this2.is_confirm.is_confirm
                  });

                case 3:
                  data = _context3.sent;

                  if (_this2.$store.state.questionModeSelect == 2 && _this2.is_confirm.is_confirm == 1 && _this2.is_confirm.get) {
                    _this2.getQuestionData({
                      getAnswer: true
                    });
                  }

                  if (!(data.code == 203)) {
                    _context3.next = 8;
                    break;
                  }

                  _this2.visible = true;
                  return _context3.abrupt("return");

                case 8:
                  resolve();

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(_ref6) {
        var id, answer_time, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = _ref6.id, answer_time = _ref6.answer_time;
                _context4.next = 3;
                return this.$http.post("/api/app/practice/storeReport", {
                  id: id,
                  answer_time: answer_time
                });

              case 3:
                data = _context4.sent;

                if (!(data.code == 203)) {
                  _context4.next = 7;
                  break;
                }

                this.visible = true;
                return _context4.abrupt("return");

              case 7:
                this.$emit("submit");

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onSubmit(_x4) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }(),
    navNext: function () {
      var _navNext = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.$refs.right.navNext();

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function navNext() {
        return _navNext.apply(this, arguments);
      }

      return navNext;
    }()
  }
};